"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var lodash_1 = require("lodash");
var template = require("@reverbdotcom/url-template");
var rql_1 = require("../../../schemas/rql");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var user_context_helpers_1 = require("@reverbdotcom/commons/dist/user_context_helpers");
var constants_1 = require("../../shared/constants");
var url_helpers_1 = require("../../shared/url_helpers");
var location_util_1 = require("../../shared/location_util");
var suggestion_collection_1 = require("./suggestion_collection");
var suggestion_1 = require("./suggestion");
var input_1 = require("./input");
var dropdown_1 = require("./dropdown");
var csp_completion_card_1 = require("./csp_completion_card");
var bind_1 = require("../../../bind");
var reverb_site_search_controller_1 = require("./reverb_site_search_controller");
var reverb_site_search_suggestions_1 = require("./reverb_site_search_suggestions");
var site_search_suggestion_1 = require("./site_search_suggestion");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var local_storage_utils_1 = require("@reverbdotcom/commons/dist/local_storage_utils");
var classNames = require('classnames');
exports.SALE_SUGGESTION_TYPE = 'SALE';
exports.RECENT_SEARCH = 'recentSearch';
var MAX_AUTOCOMPLETE_TOTAL = 5;
var MINIMUM_INPUT_LENGTH = 2;
var MAIN_COMPLETION_CONFIG = [
    { completionType: rql_1.reverb_search_CompletionType.FREE_TEXT, min: 1, max: 1 },
    { completionType: rql_1.reverb_search_CompletionType.PRODUCT_TYPE, min: 1, max: 3 },
    { completionType: rql_1.reverb_search_CompletionType.SUB_CATEGORY, min: 1, max: 3 },
    { completionType: rql_1.reverb_search_CompletionType.BRAND, min: 1, max: 3 },
    { completionType: rql_1.reverb_search_CompletionType.BRAND_MODEL, min: 1, max: 3 },
];
var SiteSearch = /** @class */ (function (_super) {
    tslib_1.__extends(SiteSearch, _super);
    function SiteSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            inputValue: '',
            lastTypedValue: '',
            open: false,
            selectedSuggestion: null,
            showDefault: true,
            suggestionCollection: new suggestion_collection_1.default([]),
            recentSearches: new suggestion_collection_1.default([]),
        };
        return _this;
    }
    Object.defineProperty(SiteSearch.prototype, "inCspAutocompletionExperiment", {
        get: function () {
            return this.inExperiment(constants_1.experiments.CSPS_IN_AUTOCOMPLETE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SiteSearch.prototype, "inParityExperiment", {
        get: function () {
            if (!this.inCspAutocompletionExperiment)
                return false;
            return this.inExperiment(constants_1.experiments.NEW_MAIN_SUGGESTIONS_AUTOCOMPLETE);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SiteSearch.prototype, "isAdmin", {
        get: function () {
            return lodash_1.get(this.props, 'user.isAdmin');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SiteSearch.prototype, "showOld", {
        get: function () {
            return lodash_1.get(location_util_1.default.queryParams(), 'ac_show_old', '') === 'true';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SiteSearch.prototype, "showOldSuggestions", {
        get: function () {
            if (!this.inParityExperiment)
                return true;
            return this.isAdmin && this.showOld;
        },
        enumerable: true,
        configurable: true
    });
    SiteSearch.prototype.inExperiment = function (exp) {
        return user_context_helpers_1.isExperimentEnabled(this.props.user, exp);
    };
    SiteSearch.prototype.hydrateRecentSearches = function () {
        var existingRecentSearches = local_storage_utils_1.getItem('RECENT_SEARCHES');
        if (!existingRecentSearches) {
            this.setState({ recentSearches: this.props.recentSearches });
            this.updateRecentSearchesInLocalStorage(this.suggestionValues(this.props.recentSearches));
        }
        else {
            this.setState({ recentSearches: reverb_site_search_suggestions_1.buildRecentSearches(existingRecentSearches) });
        }
    };
    SiteSearch.prototype.updateRecentSearches = function (query) {
        var existingRecentSearches = this.suggestionValues(this.state.recentSearches);
        var allSearches = tslib_1.__spreadArrays([query], existingRecentSearches);
        var filteredSearches = lodash_1.uniq(allSearches).slice(0, 10);
        this.updateRecentSearchesInLocalStorage(filteredSearches);
        this.setState({ recentSearches: reverb_site_search_suggestions_1.buildRecentSearches(filteredSearches) });
    };
    SiteSearch.prototype.updateRecentSearchesInLocalStorage = function (queries) {
        local_storage_utils_1.setItem('RECENT_SEARCHES', queries);
    };
    SiteSearch.prototype.hasMinimumLength = function (query) {
        return query.length >= MINIMUM_INPUT_LENGTH;
    };
    SiteSearch.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('click', this.handleSearchInputClick);
        this.hydrateRecentSearches();
    };
    SiteSearch.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('click', this.handleSearchInputClick);
    };
    // v3 suggestions, will slowly be strangled.
    SiteSearch.prototype.fetchSuggestions = function (query) {
        var _this = this;
        if (!this.hasMinimumLength(query) || !this.showOldSuggestions) {
            this.setState({
                suggestionCollection: new suggestion_collection_1.default([]),
            });
            return;
        }
        this.props.fetchSuggestions(query).then(function (suggestionCollection) {
            var groups = lodash_1.get(suggestionCollection, 'suggestions', []);
            if (groups.length === 0) {
                _this.setState({
                    suggestionCollection: new suggestion_collection_1.default([_this.suggestionGroup([], true)]),
                });
                return;
            }
            var suggestions = lodash_1.get(groups, '[0].results', []);
            _this.addSaleSuggestion(suggestions);
            _this.setState({ suggestionCollection: suggestionCollection });
        });
    };
    // rql completions: csp
    SiteSearch.prototype.fetchCompletions = function (query) {
        if (!this.hasMinimumLength(query))
            return;
        this.props.data.refetch({ query: query, skip: false });
    };
    SiteSearch.prototype.handleClickOutside = function (event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.toggleDropdown(false);
        }
    };
    SiteSearch.prototype.handleSearchInputClick = function (event) {
        var classList = lodash_1.get(event, 'target.classList', '');
        if (!classList.contains('site-search__controls__input'))
            return null;
        tracker_1.trackView({ componentName: reverb_site_search_controller_1.COMPONENT_NAME });
    };
    SiteSearch.prototype.toggleDropdown = function (dir, inputValues) {
        if (inputValues === void 0) { inputValues = {}; }
        this.setState(tslib_1.__assign({ open: dir }, inputValues));
    };
    SiteSearch.prototype.suggestionCollection = function () {
        if (this.shouldShowRecentSearches())
            return new suggestion_collection_1.default(this.state.recentSearches.suggestions);
        if (!this.hasMinimumLength(this.state.inputValue))
            return new suggestion_collection_1.default([]);
        var groups = [
            { show: this.showOldSuggestions, suggestions: this.oldSuggestions },
            { show: this.inParityExperiment, suggestions: this.mainSuggestions },
            { show: function () { return true; }, suggestions: this.cspSuggestions },
        ]
            .filter(function (_a) {
            var show = _a.show;
            return show;
        })
            .reduce(function (acc, _a) {
            var suggestions = _a.suggestions;
            return acc.concat(suggestions());
        }, [])
            .filter(function (group) { return group.results.length > 0; });
        var collection = new suggestion_collection_1.default(groups);
        collection.flatSuggestions.forEach(function (suggestion, idx) { return suggestion.position = idx; });
        return collection;
    };
    SiteSearch.prototype.handleInputChange = function (value) {
        var _this = this;
        this.fetchCompletions(value);
        this.setState({
            open: true,
            inputValue: value,
            lastTypedValue: value,
            selectedSuggestion: null,
            showDefault: false,
        }, function () { return _this.fetchSuggestions(value); });
    };
    SiteSearch.prototype.selectSuggestion = function (selectedSuggestion) {
        this.setState({
            inputValue: selectedSuggestion.value,
        });
        this.closeSuggestions();
        this.props.selectSuggestion(selectedSuggestion, this.suggestionCollection().flatSuggestions, this.state.lastTypedValue);
    };
    SiteSearch.prototype.handleSubmitClick = function (evt) {
        evt.preventDefault();
        this.submitRawQuery(this.state.inputValue);
    };
    SiteSearch.prototype.submitRawQuery = function (query) {
        if (!query) {
            return;
        }
        this.closeSuggestions();
        this.updateRecentSearches(query);
        this.props.submitQuery(query, this.suggestionCollection().flatSuggestions, this.state.lastTypedValue);
    };
    SiteSearch.prototype.closeSuggestions = function () {
        this.toggleDropdown(false, {
            lastTypedValue: '',
            selectedSuggestion: null,
        });
        this.textInput.blur();
    };
    SiteSearch.prototype.setSelectedSuggestion = function (selectedSuggestion) {
        this.setState({
            selectedSuggestion: selectedSuggestion,
            inputValue: lodash_1.get(selectedSuggestion, 'value', ''),
        });
    };
    SiteSearch.prototype.bindInputRef = function (node) {
        if (!node) {
            return;
        }
        this.textInput = node.textInput;
    };
    SiteSearch.prototype.bindWrapperRef = function (node) {
        if (!node) {
            return;
        }
        this.wrapperRef = node;
    };
    SiteSearch.prototype.shouldShowRecentSearches = function () {
        var _a = this.state, inputValue = _a.inputValue, selectedSuggestion = _a.selectedSuggestion;
        if (inputValue.length === 0) {
            return true;
        }
        if (selectedSuggestion && selectedSuggestion.type === exports.RECENT_SEARCH) {
            return true;
        }
        return false;
    };
    SiteSearch.prototype.oldSuggestions = function () {
        return lodash_1.get(this.state.suggestionCollection, 'suggestions', [this.suggestionGroup()]);
    };
    SiteSearch.prototype.addSaleSuggestion = function (suggestions) {
        if (!this.props.siteBanner)
            return;
        var _a = this.props.siteBanner, saleUrl = _a.saleUrl, heading = _a.heading;
        if (!saleUrl || !heading)
            return;
        var query = this.state.lastTypedValue.trim();
        suggestions.unshift(new suggestion_1.default({
            url: template.parse(saleUrl + "{?query*}").expand({ query: { query: query } }),
            filter_value: heading,
            type: exports.SALE_SUGGESTION_TYPE,
            value: query,
        }, site_search_suggestion_1.default));
    };
    SiteSearch.prototype.cspSuggestions = function () {
        if (!this.props.data.completions)
            return [this.suggestionGroup()];
        var cspCompletion = this.props.data.completions.completions.find(function (c) { return c.type === 'CSP'; });
        if (!cspCompletion)
            return [];
        // Ensure we're only showing CSPs that have inventory
        var cspsWithListings = cspCompletion.options
            .filter(function (c) { return c.completionPayload.inventoryNew.listingCount + c.completionPayload.inventoryUsed.listingCount > 0; })
            .slice(0, 5);
        var suggestions = cspsWithListings.map(function (o) {
            return new suggestion_1.default({
                type: rql_1.reverb_search_CompletionType.CSP,
                completion: o,
                value: o.output,
                url: url_helpers_1.default.cspPath(o.slug),
            }, csp_completion_card_1.default);
        });
        return [this.suggestionGroup(suggestions)];
    };
    SiteSearch.prototype.mainSuggestions = function () {
        var _this = this;
        if (!this.props.data.completions)
            return [this.suggestionGroup([], true)];
        var total = 0;
        var buildSuggestions = function (_a) {
            var completionType = _a.completionType, min = _a.min, max = _a.max;
            var suggestions = _this.suggestionsBy(completionType, max);
            total += suggestions.length;
            return { suggestions: suggestions, min: min };
        };
        var resize = function (suggestions, min) {
            var excess = total - MAX_AUTOCOMPLETE_TOTAL;
            if (excess > 0 && suggestions.length > min) {
                var size = suggestions.length;
                var offset = size - min;
                var hasExcess = excess >= offset;
                total -= hasExcess ? offset : size - (size - excess);
                suggestions = suggestions.slice(0, hasExcess ? min : size - excess);
            }
            return suggestions;
        };
        var sizedSuggestionsGroups = MAIN_COMPLETION_CONFIG
            .map(buildSuggestions)
            .reduceRight(function (acc, _a) {
            var suggestions = _a.suggestions, min = _a.min;
            return [resize(suggestions, min)].concat(acc);
        }, []);
        var suggestionsGroups = lodash_1.chain(this.orderMainSuggestions(sizedSuggestionsGroups))
            .flatten()
            .uniqBy(function (s) { return s.value + s.context; })
            .value();
        reverb_site_search_suggestions_1.addCurrentPageSuggestion(suggestionsGroups, this.state.lastTypedValue.trim());
        this.addSaleSuggestion(suggestionsGroups);
        return [this.suggestionGroup(suggestionsGroups)];
    };
    SiteSearch.prototype.orderMainSuggestions = function (groups) {
        var inputs = this.state.lastTypedValue.trim().split(' ');
        return groups
            .map(function (group) {
            var score = inputs.reduce(function (score, input) {
                var word = input.toLowerCase();
                var inc = group.some(function (sugg) { return sugg.normalizeValue.includes(word); }) ? 1 : 0;
                return score + inc;
            }, 0);
            return { score: score, group: group };
        })
            .sort(function (a, b) { return b.score - a.score; })
            .map(function (_a) {
            var group = _a.group;
            return group;
        });
    };
    SiteSearch.prototype.suggestionGroup = function (suggestions, withSale) {
        if (suggestions === void 0) { suggestions = []; }
        if (withSale === void 0) { withSale = false; }
        if (withSale)
            this.addSaleSuggestion(suggestions);
        return { heading: null, results: suggestions };
    };
    SiteSearch.prototype.suggestionsBy = function (completionType, limit) {
        var _this = this;
        var completion = this.props.data.completions.completions.find(function (c) { return c.type === completionType; });
        if (!completion)
            return [];
        return completion.options.slice(0, limit).map(function (o) {
            return _this.buildMainSuggestion(o, completionType, _this.suggestionUrl(o, completionType));
        });
    };
    SiteSearch.prototype.suggestionUrl = function (option, completionType) {
        var make = function (params) { return url_helpers_1.FULL_MARKETPLACE_ROUTE.expand(params); };
        var scopeSlug = lodash_1.get(option, 'scope.slug', '');
        var url;
        switch (completionType) {
            case rql_1.reverb_search_CompletionType.FREE_TEXT:
            case rql_1.reverb_search_CompletionType.BRAND_MODEL:
                url = make({ query: { query: option.output }, product_type: scopeSlug });
                break;
            case rql_1.reverb_search_CompletionType.BRAND:
                url = make({ query: { make: option.slug }, product_type: scopeSlug });
                break;
            case rql_1.reverb_search_CompletionType.PRODUCT_TYPE:
                url = make({ product_type: option.slug });
                break;
            case rql_1.reverb_search_CompletionType.SUB_CATEGORY:
                url = make({ product_type: scopeSlug, category: option.slug });
                break;
            default:
                url = make({ query: { query: option.output } });
        }
        return url;
    };
    SiteSearch.prototype.buildMainSuggestion = function (option, completionType, url) {
        var scope = lodash_1.get(option, 'scope.output', '');
        return new suggestion_1.default({
            url: url,
            filter_value: scope,
            type: completionType,
            completion: option,
            value: option.output,
        }, site_search_suggestion_1.default);
    };
    SiteSearch.prototype.suggestionValues = function (suggestions) {
        return suggestions.flatSuggestions.map(function (suggestion) { return suggestion.value; });
    };
    SiteSearch.prototype.suggestions = function () {
        if (this.shouldShowRecentSearches()) {
            return lodash_1.get(this.state.recentSearches, 'suggestions', []);
        }
        return lodash_1.get(this.suggestionCollection(), 'suggestions', []);
    };
    SiteSearch.prototype.flatSuggestions = function () {
        if (this.shouldShowRecentSearches()) {
            return this.state.recentSearches.flatSuggestions;
        }
        return lodash_1.get(this.suggestionCollection(), 'flatSuggestions', []);
    };
    SiteSearch.prototype.value = function () {
        var value;
        if (this.state.showDefault) {
            value = (this.state.inputValue || this.props.defaultValue);
        }
        else {
            value = this.state.inputValue;
        }
        return value || '';
    };
    SiteSearch.prototype.renderDropdown = function () {
        var suggestions = this.suggestions();
        if (suggestions.length === 0)
            return null;
        return (React.createElement(dropdown_1.default, { suggestions: suggestions, lastTypedValue: this.state.lastTypedValue, selectedSuggestion: this.state.selectedSuggestion, selectSuggestion: this.selectSuggestion }));
    };
    SiteSearch.prototype.render = function () {
        var flatSuggestions = this.flatSuggestions();
        var classnames = classNames('site-search', { 'site-search--active': this.state.open });
        var underlayClassnames = classNames('site-search__underlay', 
        // show when input is focused and there's either recent searches or typed chars length is > 1
        { 'site-search__underlay--active': this.state.open &&
                (flatSuggestions.length > 0 || this.state.inputValue.length > 0) });
        return (React.createElement("div", { className: underlayClassnames, onClick: function () { } },
            React.createElement("div", { className: classnames, ref: this.bindWrapperRef },
                React.createElement("div", { className: "site-search__controls" },
                    React.createElement(input_1.default, { ref: this.bindInputRef, value: this.value(), handleInputChange: this.handleInputChange, toggleDropdown: this.toggleDropdown, suggestions: flatSuggestions, setSelectedSuggestion: this.setSelectedSuggestion, submit: this.submitRawQuery, selectSuggestion: this.selectSuggestion, selectedSuggestion: this.state.selectedSuggestion, placeholderText: this.props.placeholderText, "aria-label": I18n.t('discovery.siteSearch.placeholder') }),
                    React.createElement("a", { className: "site-search__controls__submit", rel: "submit-form", onClick: this.handleSubmitClick })),
                this.renderDropdown())));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "handleClickOutside", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "handleSearchInputClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "toggleDropdown", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "suggestionCollection", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "handleInputChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "selectSuggestion", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "handleSubmitClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "submitRawQuery", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "setSelectedSuggestion", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "bindInputRef", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "bindWrapperRef", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "oldSuggestions", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "cspSuggestions", null);
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearch.prototype, "mainSuggestions", null);
    return SiteSearch;
}(React.Component));
exports.SiteSearch = SiteSearch;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["query Core_Search_CompletionsQuery(\n    $query: String\n    $skip: Boolean!\n  ) {\n    completions(\n      input: {\n        query: $query\n      }\n    ) @skip(if: $skip) {\n      completions {\n        text\n        type\n        options {\n          score\n          slug\n          id\n          text\n          output\n          scope {\n            output\n            slug\n          }\n          completionPayload {\n            thumbnailUrl\n            inventoryNew {\n              listingCount\n              listingMinPrice {\n                cents\n                currency\n              }\n            }\n            inventoryUsed {\n              listingCount\n              listingMinPrice {\n                cents\n                currency\n              }\n            }\n          }\n        }\n      }\n    }\n  }"], ["query Core_Search_CompletionsQuery(\n    $query: String\n    $skip: Boolean!\n  ) {\n    completions(\n      input: {\n        query: $query\n      }\n    ) @skip(if: $skip) {\n      completions {\n        text\n        type\n        options {\n          score\n          slug\n          id\n          text\n          output\n          scope {\n            output\n            slug\n          }\n          completionPayload {\n            thumbnailUrl\n            inventoryNew {\n              listingCount\n              listingMinPrice {\n                cents\n                currency\n              }\n            }\n            inventoryUsed {\n              listingCount\n              listingMinPrice {\n                cents\n                currency\n              }\n            }\n          }\n        }\n      }\n    }\n  }"]))), {
    options: function (ownProps) {
        return {
            variables: {
                query: ownProps.defaultValue,
                skip: true,
            },
        };
    },
});
exports.default = user_context_provider_1.withUserContext(connect(SiteSearch));
var templateObject_1;
//# sourceMappingURL=site_search.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/site_search.js
// module id = 3Ir9
// module chunks = 20 21